export function labelToTestId(label: string) {
    return label.replace(/\s+/g, '-').toLowerCase();
}
